<script setup lang="ts">
import type { Component, HTMLAttributes } from 'vue'
import { cn } from '@scripts/utils.js'

const {
    as = 'button',
    color = 'neutral',
    size = 'normal',
    ...props
} = defineProps<{
    as?: string | Component
    color?: 'white' | 'neutral' | 'primary'
    size?: 'icon' | 'normal'
    class?: HTMLAttributes['class']
}>()

console.log(props)
</script>

<template>
    <component
        :is="as"
        :class="
            cn(
                'cursor-pointer rounded font-medium tracking-tight text-black disabled:cursor-not-allowed',
                {
                    'hover:bg-neutral bg-white': color === 'white',
                    'bg-neutral': color === 'neutral',
                    'bg-brand text-brand-foreground hover:brightness-105':
                        color === 'primary',
                    'inline-flex items-center gap-1 px-3 py-1.5':
                        size === 'normal',
                    'flex size-9 items-center justify-center [&_svg]:size-6':
                        size === 'icon',
                },
                props?.class
            )
        "
        v-bind="{ ...props }"
    >
        <slot />
    </component>
</template>
